import axios from "axios";
import { BASE_URL } from "./Constants";

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

export async function adaptFile(formData) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.post(`/gpt/adapt`, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function adaptToGdoc(formData) {
  try {
    // const token = Cookies.get("user");
    const response = await instance.post(`/gpt/gdoc`, formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}

export async function postBlankFile(body) {
  try {
    const response = await instance.post(`/gpt/blank`, body);

    const data = response.data;
    return data;
  } catch (error) {
    console.error(error);
  }
}
